import { DialogProps } from '@fortem-monorepo/react-ui'
import { SubmitButton } from '@fortem-monorepo/react-ui'
import { Button } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { RunRiskForm } from '@/components/forms/pricing-interface/RunRiskForm/RunRiskForm'
import { RunRiskFormFields } from '@/components/forms/pricing-interface/RunRiskForm/RunRiskFormFields'

export interface RunRiskModalProps extends DialogProps {}

export const RunRiskModal: React.FC<RunRiskModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <RunRiskForm defaultValues={{ input_type: 'default_risk', instance_tag: 'LOCALINST1' }}>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Run Risk</DialogTitle>
                </DialogHeader>
                <div className="my-6">
                  <RunRiskFormFields />
                </div>
                <DialogFooter>
                  <Button
                    type="button"
                    variant={'destructive'}
                    size="sm"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </RunRiskForm>
      </DialogContent>
    </Dialog>
  )
}
